const COMMON_AVAILABLE_HOTKEYS = {
  DOWN: {
    hotkey: 'down',
    description:
      'Activate the dish list navigation for first use / Select the next table row / Navigate inside a select dropdown',
  },
  UP: {
    hotkey: 'up',
    description:
      'Select the previous table row / Navigate inside a select dropdown',
  },
  LEFT: {
    hotkey: 'left',
    description:
      'Select the next table cell / Collapse an option when navigating inside a tree select',
  },
  RIGHT: {
    hotkey: 'right',
    description:
      'Select the previous table cell / Expand an option when navigating inside a tree select',
  },
  CMD_LEFT: {
    hotkey: 'cmd+left',
    description: 'Go to previous page',
  },
  CMD_RIGHT: {
    hotkey: 'cmd+right',
    description: 'Go to next page',
  },
  CTRL_LEFT: {
    hotkey: 'ctrl+left',
    description: 'Go to previous page',
  },
  CTRL_RIGHT: {
    hotkey: 'ctrl+right',
    description: 'Go to next page',
  },
  SHIFT_DOWN: {
    hotkey: 'shift+down',
    description: 'Go to end of list',
  },
  SHIFT_UP: {
    hotkey: 'shift+up',
    description: 'Go to start of list',
  },
  SHIFT_LEFT: {
    hotkey: 'shift+left',
    description: 'Go to start of row',
  },
  SHIFT_RIGHT: {
    hotkey: 'shift+right',
    description: 'Go to end of row',
  },
  L: {
    hotkey: 'L',
    description: 'Open/close the hotkey legend',
  },
}

export default COMMON_AVAILABLE_HOTKEYS
